import { CurrentGameResponseData } from "@lib/titan2-slingo/dist/api/data/CurrentGameResponseData";
import { ExtendedConfigData } from "../../data/ExtendedConfigData";
import { ExtendedGameUpdateData } from "../../data/ExtendedGameUpdateData";
import { ApiConstants } from "../../enum/ApiConstants";
/**
 * ExtendedCurrentGameResponseData.ts
 */
export class ExtendedCurrentGameResponseData extends CurrentGameResponseData {
    solidifyGameUpdate() {
        if (this.dataExists(this.data)) {
            this.gameUpdate = new ExtendedGameUpdateData(this.data);
        }
    }
    solidifyConfig() {
        const config = this.data.getDataObject(ApiConstants.PROPERTY_CONFIG);
        if (this.dataExists(config)) {
            this.config = new ExtendedConfigData(config);
        }
    }
}
//# sourceMappingURL=ExtendedCurrentGameResponseData.js.map